import React, { useState } from "react";
import { HiMenu, HiX } from "react-icons/hi";

function Header() {

   const [isOpen, setIsOpen] = useState(false);

    return (
        <header className="sticky top-0 z-50 bg-[#f0ead6] shadow-2xl drop-shadow-lg px-6 md:px-20 py-4">
         <div className="flex items-center justify-between">
            <div>
               <span className="text-black hover:text-[#80755a] font-semibold text-lg">
                  Nimrekha 
               </span>
               <span className="text-[#a0522d] mx-1 hover:text-[#c19a6b] font-semibold text-lg">
                  Weerasinghe
               </span>
            </div>

            <ul className="hidden md:flex space-x-6">
                <li>
                   <a className="text-gray-600 hover:text-black" href="#home">Home</a>
                </li>
                <li>
                   <a className="text-[#a0522d] hover:text-black" href="#about">About</a>
                </li>
                <li>
                   <a className="text-gray-600 hover:text-black" href="#projects">Projects</a>
                </li>
                <li>
                   <a className="text-[#a0522d] hover:text-black" href="#skills">Skills</a>
                </li>
                <li>
                   <a className="text-gray-600 hover:text-black" href="#contact">Contact</a>
                </li>
            </ul>

            <div className="md:hidden">
               <button onClick={() => setIsOpen(!isOpen)}>
                  {isOpen ? (
                     <HiX className="text-2xl text-[#964b00]" />
                  ) : (
                     <HiMenu className="text-2xl text-[#964b00]" />
                  )}
               </button>
            </div>
         </div>
            
         {isOpen && (
         <ul className="flex flex-col space-y-4 mt-4 md:hidden">
            <li><a className="text-gray-600 hover:text-black" href="#home" onClick={() => setIsOpen(false)}>Home</a></li>
            <li><a className="text-[#a0522d] hover:text-black" href="#about" onClick={() => setIsOpen(false)}>About</a></li>
            <li><a className="text-gray-600 hover:text-black" href="#projects" onClick={() => setIsOpen(false)}>Projects</a></li>
            <li><a className="text-[#a0522d] hover:text-black" href="#skills" onClick={() => setIsOpen(false)}>Skills</a></li>
            <li><a className="text-gray-600 hover:text-black" href="#contact" onClick={() => setIsOpen(false)}>Contact</a></li>
         </ul>
         )}
             
      </header>
    )
}

export default Header;